exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".summaryPrice__price___2Oy8Z {\n  font-size: 17px;\n  line-height: 26px;\n  margin-bottom: 23px;\n  font-weight: 700;\n  color: #f94144;\n  margin-right: 6px;\n  display: inline-block; }\n\n.summaryPrice__prevPrice___1vdOo {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 20px;\n  text-decoration-line: line-through;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none; }\n\n.summaryPrice__priceM2___2DI6_ {\n  color: #f94144;\n  font-size: 12px;\n  font-weight: 600;\n  margin-bottom: 23px; }\n", ""]);

// exports
exports.locals = {
	"price": "summaryPrice__price___2Oy8Z",
	"prevPrice": "summaryPrice__prevPrice___1vdOo",
	"priceM2": "summaryPrice__priceM2___2DI6_"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/AdDetailsPage/AdDetailsPageMobile/SummarySection/SummaryPrice/summaryPrice.scss
// module id = 4318
// module chunks = 6